import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

interface BulkTagToolbarProps {
  selectedCount: number;
  onApply: (tags: string[]) => void;
  onCancel: () => void;
}

export function BulkTagToolbar({
  selectedCount,
  onApply,
  onCancel,
}: BulkTagToolbarProps) {
  const [tagInput, setTagInput] = useState("");

  const handleApply = () => {
    const tags = tagInput
      .split(",")
      .map((t) => t.trim().toLowerCase())
      .filter(Boolean);
    if (tags.length > 0 && selectedCount > 0) {
      onApply(tags);
      setTagInput("");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 2,
        py: 1,
        bgcolor: "action.selected",
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Typography
        variant="caption"
        sx={{ fontWeight: 600, whiteSpace: "nowrap" }}
      >
        {selectedCount} selected
      </Typography>
      <TextField
        size="small"
        placeholder="Tags (comma-separated)"
        value={tagInput}
        onChange={(e) => setTagInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") handleApply();
        }}
        sx={{
          flex: 1,
          "& .MuiInputBase-input": { fontSize: "0.8rem", py: 0.5 },
        }}
      />
      <Button
        size="small"
        variant="contained"
        onClick={handleApply}
        disabled={!tagInput.trim()}
      >
        Apply
      </Button>
      <Button size="small" onClick={onCancel}>
        Cancel
      </Button>
    </Box>
  );
}
